<p-dialog
	[(visible)]="isDialogVisible"
	[baseZIndex]="10000"
	[modal]="true"
	[style]="{ width: '700px', 'max-height': '600px' }">
	<ng-template #header>
		<div class="dialog-header-container">
			<div class="dialog-header-text">
				<span>{{ 'conditional-formatting' | translate }}</span>
			</div>
		</div>
	</ng-template>
	<ng-template #content>
		<div [formGroup]="form">
			<div formArrayName="items">
				@for (conditionForm of items.controls; track conditionForm; let i = $index; let count = $count) {
					<div>
						<div class="ui-g border mt-2" [formGroupName]="i">
							<div class="ui-lg-1 ui-md-1 ui-g-1 flex align-items-center justify-content-center">
								<button
									pButton
									class="ui-green-button"
									icon="fas fa-minus"
									[disabled]="count === 1"
									(click)="removeItem(i)"></button>
							</div>
							<div class="ui-lg-10 ui-md-10 ui-g-10 row-label">
								<div class="ui-g-12 box-zero">
									<div class="ui-lg-4 ui-md-6 ui-g-12">
										<label for="method">{{ 'method' | translate }}</label>
										<p-select
											id="method"
											class="w-100"
											formControlName="method"
											[options]="methodOptions"
											appendTo="body"></p-select>
									</div>
									@switch (field.type) {
										@case ('text') {
											<ng-template [ngTemplateOutlet]="text"></ng-template>
										}
										@case ('double') {
											<ng-template [ngTemplateOutlet]="numeric"></ng-template>
										}
										@case ('date') {
											<ng-template [ngTemplateOutlet]="date"></ng-template>
										}
									}
									<ng-template #text>
										<div class="ui-lg-4 ui-md-6 ui-g-12">
											<label for="firstValue">{{ 'value' | translate }}</label>
											<p-multiSelect
												class="w-100"
												formControlName="firstValue"
												[options]="fieldDataOptions"
												[maxSelectedLabels]="2"
												[selectedItemsLabel]="'{1} ' + ('value-selected' | translate)"
												[filter]="true"
												appendTo="body"></p-multiSelect>
										</div>
									</ng-template>
									<ng-template #numeric>
										<div class="ui-lg-4 ui-md-6 ui-g-12">
											<label for="firstValue">{{ 'first-value' | translate }}</label>
											<p-inputNumber
												id="firstValue"
												class="w-100"
												styleClass="value-input"
												formControlName="firstValue"
												[minFractionDigits]="2"
												[placeholder]="'enterValue' | translate"></p-inputNumber>
										</div>
										@if (conditionForm.get('method').value === FieldConditionalFormattingMethod.RANGE) {
											<div class="ui-lg-4 ui-md-6 ui-g-12">
												<label for="lastValue">{{ 'last-value' | translate }}</label>
												<p-inputNumber
													id="lastValue"
													class="w-100"
													styleClass="value-input"
													formControlName="lastValue"
													[minFractionDigits]="2"
													[placeholder]="'enterValue' | translate"></p-inputNumber>
											</div>
										}
									</ng-template>
									<ng-template #date>
										<div class="ui-lg-4 ui-md-6 ui-g-12">
											<label for="firstValue">{{ 'first-value' | translate }}</label>
											<p-datepicker
												formControlName="firstValue"
												[dateFormat]="'dd/mm/yy'"
												[showIcon]="true"
												appendTo="body"></p-datepicker>
										</div>
										@if (conditionForm.get('method').value === FieldConditionalFormattingMethod.RANGE) {
											<div class="ui-lg-4 ui-md-6 ui-g-12">
												<label for="lastValue">{{ 'last-value' | translate }}</label>
												<p-datepicker
													formControlName="lastValue"
													[dateFormat]="'dd/mm/yy'"
													[showIcon]="true"
													appendTo="body"></p-datepicker>
											</div>
										}
									</ng-template>
								</div>
								<div class="ui-g-12 box-zero">
									<div class="ui-lg-4 ui-md-6 ui-g-12">
										<label for="fontStyle">{{ 'font-style' | translate }}</label>
										<p-select
											id="fontStyle"
											class="w-100"
											formControlName="fontStyle"
											[options]="fontStyleOptions"
											appendTo="body"></p-select>
									</div>
									<div class="ui-lg-4 ui-md-6 ui-g-12">
										<label for="fontSize">{{ 'font-size' | translate }}</label>
										<p-select
											id="fontSize"
											class="w-100"
											formControlName="fontSize"
											[options]="fontSizeOptions"
											appendTo="body"></p-select>
									</div>
									<div class="ui-lg-2 ui-md-6 ui-g-12">
										<label for="fontColor">{{ 'font-color' | translate }}</label>
										<p-colorPicker
											id="fontColor"
											format="hex"
											formControlName="fontColor"
											appendTo="body"></p-colorPicker>
									</div>
								</div>
							</div>
							@if (i === items.controls.length - 1) {
								<div class="ui-lg-1 ui-md-1 ui-g-1 flex align-items-center justify-content-center">
									<button (click)="addItem()" class="ui-green-button" icon="fas fa-plus" pButton></button>
								</div>
							}
						</div>
					</div>
				}
			</div>
		</div>
	</ng-template>
	<ng-template #footer>
		<div class="text-right ui-g-12 ui-lg-12 ui-md-12">
			<button (click)="clearFormatting()" [label]="'clear' | translate" class="ui-dark-button" pButton></button>
			<button (click)="save()" [label]="'save' | translate" class="ui-green-button" pButton></button>
		</div>
	</ng-template>
</p-dialog>
